/**
 * PdpSelectableCard to be used for fulfillment cards on PDP
 *
 * @module views/components/PdpSelectableCard
 * @memberof -Common
 */
import './PdpSelectableCard.scss';

import React from 'react';

import PropTypes from 'prop-types';

import SelectableCard from '@ulta/core/components/SelectableCard/SelectableCard';




/**
 * Represents a PdpSelectableCard component
 *
 * @method
 * @param {PdpSelectableCardProps} props - React properties passed from composition
 * @returns PdpSelectableCard
 */
export const PdpSelectableCard = ( props ) => {
  const {
    alignment = defaultProps.alignment,
    fulfillmentType,
    selectAction,
    updateVariantAction,
    icon,
    onChange,
    selected,
    subtitle,
    tileState,
    title
  } = props;

  let disabled = tileState === 'disabled';
  let style = tileState === 'unavailable' ? 'grayscale' : 'default';

  return (
    <>
      <li className='PdpSelectableCard SelectableCard'
        key={ fulfillmentType }
      >
        <SelectableCard
          icon={ icon }
          title={ title?.text }
          supportingText={ subtitle }
          isSelected={ selected }
          disabled={ disabled }
          alignment={ alignment }
          inputType={ 'button' }
          titleTextStyle='body'
          style={ style }
          handleOnchange={ () => onChange( { type : fulfillmentType, selectAction, updateVariantAction } ) }
        />
      </li>
    </>
  );
} ;


/**
 * Property type definitions
 * @typedef PdpSelectableCardProps
 * @type {object}
 * @property {string} alignment - Sets alignment style
 * @property {boolean} selected- Sets selected or not
 * @property {string} fulfillmentType- Sets fulfillmentType
 * @property {string} icon - Sets icon
 * @property {function} onChange - Function will change value
 * @property {string} subtitle - Sets the sub title
 * @property {string} tileState - tileState
 * @property {object} title - Sets title
 */
export const propTypes = {
  alignment: PropTypes.string,
  selected: PropTypes.bool,
  fulfillmentType: PropTypes.string,
  icon: PropTypes.string,
  onChange: PropTypes.func,
  subtitle: PropTypes.string,
  tileState: PropTypes.string,
  title: PropTypes.object
};

/**
 * Default values for passed properties
 *
 * @type {object}
 * @property {string} alignment = `center` - Sets center alignment
 */
export const defaultProps = {
  alignment: 'center'
};

PdpSelectableCard.propTypes = propTypes;
PdpSelectableCard.defaultProps = defaultProps;

export default PdpSelectableCard;
